import { render, staticRenderFns } from "./FirmaPost.vue?vue&type=template&id=14f04629"
import script from "./FirmaPost.vue?vue&type=script&lang=js"
export * from "./FirmaPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports